/** Case/whitespace-insensitive key for matching geo codes against each other — a partner's
 *  `GeoRegion`/`GeoMarket`, or a Key Initiative row's resolved market/country. Shared by
 *  `getRevenueAndSobHierarchyRows` and `getCockpitInitiativeHierarchyRows` so the two never drift
 *  apart. */
export const normalizeGeoKey = (value?: string | null): string => value?.trim().toLowerCase() ?? ''
